import React from 'react';
import styled from 'styled-components';

const Sidebar = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 24px;
`;

const Progress = styled.div`
  padding: 24px;
  border-bottom: 1px solid #edf2f7;

  h2 {
    font-size: 1rem;
    color: #2d3748;
    margin-bottom: 16px;
  }

  .progress-bar {
    width: 100%;
    height: 8px;
    background: #edf2f7;
    border-radius: 4px;
    overflow: hidden;

    .fill {
      height: 100%;
      background: #34574A;
      transition: width 0.3s ease;
    }
  }

  .steps-completed {
    font-size: 0.875rem;
    color: #718096;
    margin-top: 8px;
  }
`;

const Steps = styled.div`
  padding: 16px 0;
`;

const Step = styled.button`
  width: 100%;
  padding: 16px 24px;
  background: ${props => props.$completed ? '#e6f9ed' : 'none'};
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${props => props.$active ? '#34574A' : '#4a5568'};
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.$active ? '#f0fff4' : props.$completed ? '#d1f7e1' : '#f7fafc'};
  }

  .number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    font-weight: 500;
    background: ${props => props.$active ? '#34574A' : props.$completed ? '#22c55e' : '#edf2f7'};
    color: ${props => props.$active || props.$completed ? 'white' : '#4a5568'};
    border: ${props => props.$completed ? '2px solid #22c55e' : 'none'};
    transition: background 0.3s, color 0.3s, border 0.3s;
  }

  .text {
    font-size: 0.875rem;
    font-weight: 500;
  }
`;

export default function ProgressSteps({ steps, currentStep, completedSteps, onStepClick }) {
  const progress = Math.round((completedSteps.length / steps.length) * 100);
  return (
    <Sidebar>
      <Progress $progress={progress}>
        <h2>Progresso</h2>
        <div className="progress-bar">
          <div className="fill" style={{ width: `${progress}%`, background: progress === 100 ? '#22c55e' : '#34574A' }} />
        </div>
        <div className="steps-completed">
          {completedSteps.length} de {steps.length} etapas concluídas
        </div>
      </Progress>
      <Steps>
        {steps.map((step) => (
          <Step
            key={step.number}
            $active={currentStep === step.number}
            $completed={completedSteps.includes(step.number)}
            onClick={() => onStepClick && onStepClick(step.number)}
          >
            <span className="number">{step.number}</span>
            <span className="text">{step.text}</span>
          </Step>
        ))}
      </Steps>
    </Sidebar>
  );
}
